<template>
  <div v-if="dadosProposta.dadosCliente" class="wrapperPage pt-8">
    <div class="container flex flex-row items-center justify-between">
      <div class="logo ml-4 w-full">
        <img
          class="img-logo"
          src="../../assets/images/logo/logo-bpseguradora.svg"
        />
      </div>
      <div class="w-full flex flex-col p-1 text-sm">
        <h3 class="flex justify-end">{{ titulo }}</h3>
        <h6 class="flex justify-end" v-if="titulo === 'Apólice de Seguro'">
          {{ formataNumeroApolice(dadosProposta.policyNumber) }}
        </h6>
      </div>
    </div>

    <div class="container">
      <!-- DADOS PROPOSTA -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">DADOS DA PROPOSTA</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>N° Proposta:</b>
              {{ formataNumeroProposta(dadosProposta.proposalNumber) }}
            </td>
            <td class="pl-3">
              <b>N° Endosso:</b> {{ dadosProposta.idEndosso }}
            </td>
            <!-- <td class="pl-3"><b>Numero de Veículos:</b> 1</td> -->
            <td class="pl-3">
              <b>Data de Emissão: </b>{{ dadosProposta.dataEmissao }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Validade da Proposta: </b
              >{{ dadosProposta.validadeProposta }} (14 dias)
            </td>
            <td class="pl-3" colspan="2">
              <b>Vigência da Apólice: </b>00:00 de
              {{
                functions.formataDataHoraPadraoBR(
                  dadosProposta.inicioVigencia,
                  false,
                )
              }}
              até 00:00 de
              {{
                functions.formataDataHoraPadraoBR(
                  dadosProposta.fimVigencia,
                  false,
                )
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Seguradora: </b>BP SEGURADORA SA / SUSEP
              {{ SUSEP_CODE.BP_SEGURADORA }}
            </td>
            <td class="pl-3"><b>CNPJ: </b>50.180.527/0001-13</td>
            <td class="pl-3"><b>Ramo: </b>Seguro de Vida</td>
          </tr>
        </table>
      </vx-card>

      <!-- DADOS DA CORRETORA -->
      <vx-card class="mt-2 card-impressao pagebreak-inside-avoid">
        <table class="table card-impressao table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="5">DADOS DA CORRETORA</th>
          </tr>
          <tr>
            <td class="pl-3"><b>Corretora:</b> {{ dadosProposta.regional }}</td>
            <td class="pl-3">
              <b>CPF/CNPJ:</b> {{ dadosProposta.regionalCnpj }}
            </td>
            <td class="pl-3">
              <b>SUSEP:</b> {{ dadosProposta.regionalSusep }}
            </td>
            <td class="pl-3">
              <b>Cidade:</b> {{ dadosProposta.regionalCidade }}
            </td>
            <td class="pl-3"><b>UF:</b> {{ dadosProposta.regionalEstado }}</td>
          </tr>
        </table>
      </vx-card>

      <!-- DADOS PESSOAIS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">DADOS DO SEGURADO</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{
                dadosProposta.dadosCliente.associadoNomeSocial
                  ? 'Nome Social'
                  : 'Nome'
              }}</b
              >:
              {{
                dadosProposta.dadosCliente.associado
                  ? dadosProposta.dadosCliente.associado
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>CPF</b>:
              {{
                dadosProposta.dadosCliente.cpf
                  ? dadosProposta.dadosCliente.cpf
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Data de Nascimento</b>:
              {{
                dadosProposta.dadosCliente.dataNascimento != 'Invalid date'
                  ? dadosProposta.dadosCliente.dataNascimento
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Sexo de Nascimento</b>:
              {{
                dadosProposta.dadosCliente.sexo
                  ? dadosProposta.dadosCliente.sexo
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>E-mail</b>:
              {{
                dadosProposta.dadosCliente.email
                  ? dadosProposta.dadosCliente.email
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Celular</b>:
              {{
                dadosProposta.dadosCliente.celular
                  ? dadosProposta.dadosCliente.celular
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Estado Civil</b>:
              {{
                dadosProposta.dadosCliente.estadoCivil
                  ? dadosProposta.dadosCliente.estadoCivil
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Pessoal politicamente exposta?</b>:
              {{
                dadosProposta.dadosCliente.politicamenteExposto ? 'Sim' : 'Não'
              }}
            </td>
          </tr>
        </table>
      </vx-card>

      <!-- ENDEREÇO -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table">
          <tr class="title p-1 w-full">
            <th colspan="4">ENDEREÇO DO SEGURADO</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Endereço</b>:
              {{
                dadosProposta.dadosCliente.endereco
                  ? dadosProposta.dadosCliente.endereco
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Número</b>:
              {{
                dadosProposta.dadosCliente.numero
                  ? dadosProposta.dadosCliente.numero
                  : ''
              }}
            </td>
            <td class="pl-3" colspan="2">
              <b>Complemento</b>:
              {{
                dadosProposta.dadosCliente.complemento
                  ? dadosProposta.dadosCliente.complemento
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Bairro</b>:
              {{
                dadosProposta.dadosCliente.bairro
                  ? dadosProposta.dadosCliente.bairro
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Cidade</b>:
              {{
                dadosProposta.dadosCliente.cidade
                  ? dadosProposta.dadosCliente.cidade
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Estado</b>:
              {{
                dadosProposta.dadosCliente.estado
                  ? dadosProposta.dadosCliente.estado
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>CEP</b>:
              {{
                dadosProposta.dadosCliente.cep
                  ? dadosProposta.dadosCliente.cep
                  : ''
              }}
            </td>
          </tr>
        </table>
      </vx-card>

      <!-- AGRAVOS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="2">QUESTIONÁRIO DE AVALIAÇÃO DE RISCO</th>
          </tr>
          <tr v-for="(item, index) in dadosSaude" :key="index">
            <td class="pl-3">
              <b>{{ item.question }}</b>
            </td>
            <td class="pl-3">{{ item.response }}</td>
          </tr>
        </table>
      </vx-card>

      <!-- COBERTURAS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="5">COBERTURAS</th>
          </tr>
          <tr v-for="(item, index) in lifeData.coverages" :key="index">
            <td class="pl-3">
              <b>Cobertura</b>:
              {{ item.name }}
            </td>
            <td class="pl-3">
              <b>Capital Segurado</b>:
              {{ functions.formataReal(item.prize.insured_value) }}
            </td>
            <td class="pl-3">
              <b>Carência</b>:
              {{ getCarencia(item.waiting_period) }}
            </td>
            <td class="pl-3">
              <b>Franquia</b>:
              {{ getFranquia(item.deductible) }}
            </td>
          </tr>
        </table>
      </vx-card>

      <!-- DEMONSTRAÇÃO DE PRÊMIO -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">DEMONSTRAÇÃO DE PRÊMIO</th>
          </tr>
          <tr v-for="(item, index) in lifeData.coverages" :key="index">
            <td class="pl-3">
              <b>Cobertura</b>: {{ item.name }} - até
              {{ functions.formataReal(item.prize.insured_value) }}
            </td>
            <td class="pl-3">
              <b>Prêmio Líquido</b>:
              {{
                functions.formataReal(  getValorPremioLiquido(item.prize.prize, item.prize.iof)),
              }}
            </td>
            <td class="pl-3">
              <b>IOF</b>:
              {{

                functions.formataReal(  getValorIof(item.prize.prize, item.prize.iof)),
              }}
            </td>
            <td class="pl-3">
              <b>Prêmio Total</b>:
              {{ functions.formataReal(item.prize.prize) }}
            </td>
          </tr>
        </table>
      </vx-card>

      <!-- FORMA DE PAGAMENTO -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="3">FORMA DE PAGAMENTO</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Forma Pagamento</b>: {{ dadosProposta.nomePagamento }}
            </td>
            <td>
              <b>Total de Parcelas</b>:
              <span v-if="dadosProposta.nomePagamento">
                {{ dadosProposta.qtdParcelas }} x
                {{
                  functions.formataReal(  (somaValorTotalMensal(dadosProposta.produtos) * 12)) /
                      dadosProposta.qtdParcelas,
                }}
              </span>
            </td>
            <td class="pl-3">
              <b>Prêmio Total Geral</b>:
              {{
                lifeData.total_price
                  ? functions.formataReal(lifeData.total_price)
                  : null
              }}
            </td>
          </tr>
        </table>
      </vx-card>

      <!-- BENEFICIÁRIOS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">BENEFICIÁRIOS</th>
          </tr>
          <tr>
            <td class="pl-3" colspan="4">
              <b>Quem São os beneficiários?</b>:
              {{
                lifeData.legal_beneficiaries
                  ? 'Herdeiros legais'
                  : 'Beneficiários indicados'
              }}
            </td>
          </tr>
          <tr v-for="(item, index) in lifeData.beneficiaries" :key="index">
            <td class="pl-3">
              <b>Nome Completo</b>:
              {{ item.name }}
            </td>
            <td>
              <b>Grau de Parentesco</b>:
              {{ item.kinship_label }}
            </td>
            <td class="pl-3">
              <b>Data de Nascimento</b>:
              {{ formataData(item.birthdate) }}
            </td>
            <td class="pl-3">
              <b>Participação (%)</b>: {{ item.percentage }}%
            </td>
          </tr>
        </table>
      </vx-card>

      <!-- DISPOSIÇÕES GERAIS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">DISPOSIÇÕES GERAIS</th>
          </tr>
          <tr>
            <td>
              <ol>
                <li>
                  <b>1.</b> Processo SUSEP N° 15414.622609/2023-44 – PRODUTO
                  VIDA INDIVIDUAL
                </li>
                <li>
                  <b>2.</b> O registro deste plano na SUSEP não implica, por
                  parte da Autarquia, incentivo ou recomendação a sua
                  comercialização;
                </li>
                <li>
                  <b>3.</b> A aceitação do seguro estará sujeita à análise do
                  risco pela Seguradora;
                </li>
                <li>
                  <b>4.</b> Qualquer importância oferecida pelo Proponente junto
                  com a proposta tem natureza de adiantamento do prêmio;
                </li>
                <li>
                  <b>5.</b> Após o pagamento da proposta, esta só será
                  considerado apólice mediante aceite online e envio dos
                  documentos por parte do proponente em até 24h.
                </li>
                <li>
                  <b>6.</b> O não envio dos documentos e aceite online
                  acarretará na devolução do valor e cancelamento da proposta;
                </li>
                <li>
                  <b>7.</b> Os direitos e obrigações, bem como a descrição
                  completa das coberturas, riscos cobertos e excluídos,
                  encontram-se detalhadas nas condições Gerais e Especiais, que
                  integram esta Proposta;
                </li>
                <li>
                  <b>8.</b> As Condições Gerais e Especiais encontram-se
                  disponíveis no site www.bpseguradora.com.br.
                </li>
                <li>
                  <b>9.</b> A cobertura do seguro está condicionada ao pagamento
                  do prêmio.
                </li>
              </ol>
            </td>
          </tr>
        </table>
      </vx-card>

      <!-- DISPOSIÇÕES ESPECÍFICAS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">DISPOSIÇÕES ESPECÍFICAS</th>
          </tr>
          <tr>
            <td>
              Processo SUSEP <b>N° 15414.622609/2023-44</b> – PRODUTO VIDA
              INDIVIDUAL <br />
              <h5 class="mt-5">Objetivo</h5>
              <p class="mt-2">
                O presente Seguro tem por objetivo garantir o pagamento do
                Capital Segurado ao Segurado ou ao(s) seu(s) Beneficiário(s), no
                caso de ocorrência de evento coberto pelas coberturas
                contratadas, exceto de riscos excluídos, observadas as Condições
                Gerais e Contratuais do Seguro.
              </p>

              <h5 class="mt-5">Carência</h5>
              <p class="mt-2">
                O período de carência será contado a partir do início de
                vigência da cobertura, sendo estabelecido nas Condições
                Contratuais, não podendo exceder o prazo de 24 (vinte e quatro)
                meses.
              </p>
              <p class="mt-2">
                As coberturas de Morte e Auxílio Funeral terão carência de 30
                (trinta) dias, cuja contagem será a partir do início de vigência
                do Seguro, exceto para os casos de acidente.
              </p>
              <p class="mt-2">
                Não haverá a incidência de carência para Indenização Especial de
                Morte por Acidente, eventos decorrentes de acidente pessoal,
                exceto para o caso de suicídio ou sua tentativa que deverá ser
                respeitada uma carência de 24 (vinte e quatro) meses, contados a
                partir do início de vigência da cobertura.
              </p>

              <h5 class="mt-5">Franquia</h5>
              <p class="mt-2">
                Não está previsto o estabelecimento de Franquias para este plano
                de seguro.
              </p>

              <h5 class="mt-5">Vigência</h5>
              <p class="mt-2">
                A apólice terá vigência de 12 meses podendo ou não ser renovada
                pela Seguradora, tendo início à zero hora da data de aceitação
                da proposta ou de data acordada entre as partes.
              </p>

              <h5 class="mt-5">Contratação e Aceitação</h5>
              <p class="mt-2">
                O Seguro deverá ser contratado mediante o preenchimento do
                formulário do autocotador e a declaração pessoal de saúde. Após
                o pagamento será encaminhado um link para assinatura online e
                envio de documentos pessoais. Esse link ficará disponível por 24
                horas e em caso de não envio das documentações e não assinatura,
                a proposta será cancelada e o pagamento estornado.
              </p>
              <p class="mt-2">
                Declaração Pessoal de Saúde e Atividades: é o chamado
                ‘’questionário de risco’’, integrante da Proposta de
                Contratação, que deverá ser respondido e assinado pelo
                Proponente, podendo este ser por meios eletrônicos, conforme
                legislação em vigor, no qual o mesmo informará à Seguradora o
                seu estado de saúde atual e passado, bem como sua principal
                ocupação e/ou atividade e profissão.
              </p>
              <p class="mt-2">
                Recebida a Proposta de Contratação pela Seguradora, esta terá o
                prazo de 15 (quinze) dias para que seja feita a análise do
                Seguro, seja para seguros novos ou renovações, da mesma forma
                para alterações que impliquem modificação do risco. Caso a
                Seguradora, neste prazo, não manifeste a recusa da Proposta de
                Contratação por escrito ao Proponente, o Seguro considera-se
                aceito.
              </p>
              <p class="mt-2">
                A aceitação do Seguro estará sujeita à análise da Proposta de
                Contratação e/ou Risco.
              </p>
              <p class="mt-2">
                A não aceitação da Proposta de Contratação será comunicada ao
                Proponente por escrito, informando-lhe os motivos que ensejaram
                a recusa e, consequentemente, o cancelamento da Proposta de
                Contratação.
              </p>

              <h5 class="mt-5">Pagamento do Prêmio (boleto)</h5>
              <p class="mt-2">
                O pagamento será feito anualmente, cobrindo toda a vigência. O
                mesmo poderá ser feito por PIX ou cartão de crédito, sendo que
                nessa última opção o cliente poderá optar pelo parcelamento,
                caso habilitado.
              </p>

              <h5 class="mt-5">Beneficiários</h5>
              <p class="mt-2">
                Os beneficiários (quem irá receber a indenização) serão
                designados pelo Segurado, podendo ser alterados a qualquer
                momento.
              </p>
              <p class="mt-2">
                Na falta de indicação do beneficiário, o capital segurado será
                pago por metade ao cônjuge não separado judicialmente e o
                restante aos herdeiros do Segurado obedecida a ordem de vocação
                hereditária.
              </p>

              <h5 class="mt-5">Âmbito Geográfico da Cobertura</h5>
              <p class="mt-2">
                As coberturas do Seguro previstas nestas Condições Gerais
                aplicam-se para eventos cobertos ocorridos em qualquer parte do
                território nacional.
              </p>

              <h5 class="mt-5">Vigência e Renovação do Seguro</h5>
              <p class="mt-2">
                O início de vigência da Apólice será às 24 (vinte e quatro)
                horas da data de aceitação da Proposta de Contratação ou de
                outra data acordada entre a Seguradora e o Proponente, sendo
                esta ratificada no Contrato de Seguro.
              </p>

              <h5 class="mt-5">Riscos Excluídos</h5>
              <p class="mt-2">
                Este produto possui riscos excluídos que estão disponíveis para
                consulta nas Condições Gerais do Produto registrado na SUSEP
                pelo processo de <b>Nº 15414.622609/2023-44.</b> As condições
                gerais deste produto encontram-se disponíveis no endereço
                eletrônico
                <a
                  href="https://bpseguradora.com.br/documents/solucoes/vida_individual.pdf"
                  target="_blank"
                  >https://bpseguradora.com.br/documents/solucoes/vida_individual.pdf</a
                >
              </p>

              <h5 class="mt-5">Comunicação de Sinistros</h5>
              <p class="mt-2">
                Em caso de sinistro, o Segurado ou seu(s) Beneficiário(s)
                deverá(ão) comunicar o sinistro à Seguradora por e-mail em
                <b>sinistro@bpseguradora.com.br</b>, mediante o preenchimento do
                Formulário de Aviso de Sinistro a ser fornecido pela Seguradora,
                e provar inequivocadamente sua ocorrência, através da entrega
                dos documentos listados nas condições gerais desse produto.
              </p>
              <p class="mt-2">
                O prazo para pagamento da indenização, por parte da Seguradora,
                é limitado a 30 (trinta) dias contados a partir da entrega pelo
                Segurado ou Beneficiário da documentação básica necessária para
                a regulação do sinistro, definida nas Condições Gerais.
              </p>
              <p class="mt-2">
                A documentação necessária para abertura de sinistros está
                descrita nas Condições Gerais: Vida Individual, disponível no
                endereço eletrônico
                <a
                  href="https://bpseguradora.com.br/documents/solucoes/vida_individual.pdf"
                  target="_blank"
                  >https://bpseguradora.com.br/documents/solucoes/vida_individual.pdf</a
                >
              </p>

              <h5 class="mt-5">Cancelamento</h5>
              <p class="mt-2">
                Caso não haja o pagamento do primeiro prêmio, a contratação do
                seguro não estará concretizada, não existindo qualquer tipo de
                cobertura securitária, em momento algum.
              </p>
              <p class="mt-2">
                O Seguro poderá ser rescindido mediante aviso prévio de, no
                mínimo, 30 (trinta) dias, pela Seguradora, em caso de
                descumprimento das obrigações do segurado.
              </p>
            </td>
          </tr>
        </table>
      </vx-card>

      <!-- CONTRATO -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <div style="text-align: justify" class="textoContrato">
          <b
            >SUSEP: 0800 021 8484 / Site: www.susep.gov.br <br />
            Site: www.bpseguradora.com.br <br />
            Serviço de Atendimento ao Consumidor (SAC): 0800 042 9915 <br />
            Ouvidoria: 0800 042 9912 / E-mail: ouvidoria@bpseguradora.com.br
            <br
          /></b>
        </div>
        <div>
          {{
            dadosProposta.dadosAssociacao.cidade
              ? dadosProposta.dadosAssociacao.cidade
              : 'Belo Horizonte'
          }},
          {{
            functions.formatDateAndHour(
              dadosProposta.dataFinalizacao || dadosProposta.createdAt,
            )
          }}
        </div>
        <div class="flex flex-row sm:flex-row sm:justify-around mt-8">
          <div class="container-assinaturas">
            <div class="mr-5">
              <img
                class="imagem"
                src="../../assets/images/assinatura/assinatura.jpeg"
                width="100"
                height="100"
              />
              <p><b>____________________________________</b></p>
              <p><b>BP SEGURADORA SA</b></p>
              <p><b>50.180.527/0001-13</b></p>
              <!-- <P v-if="this.dadosProposta.idEmpresa == 117"
              ><b>10.476.457/0001-20</b></P
            > -->
              <!-- <P v-else><b>13.762.231/0001-84</b></P> -->
            </div>

            <div class="ml-5">
              <img
                v-if="dadosProposta.assinatura"
                class="imagem"
                :src="dadosProposta.assinatura"
                height="100"
                width="100"
                style="margin-left: 15px"
              />
              <p><b>____________________________________</b></p>
              <p>
                <b>{{ dadosProposta.dadosCliente.associado }}</b>
              </p>
              <P
                ><b>{{ dadosProposta.dadosCliente.cpf || '-' }}</b></P
              >
            </div>
          </div>
        </div>

        <div class="mt-5">
          <h6 class="textoRodape">
            Para ter acesso as condições gerais de produtos, acesse:
            <a href="https://bpseguradora.com.br/solucoes/" target="_blank"
              >https://bpseguradora.com.br/solucoes/</a
            >
            Processo Susep N° 15414.622609/2023-44 – PRODUTO VIDA INDIVIDUAL A
            contratação não automática do contrato de seguro somente poderá ser
            feita mediante proposta preenchida e assinada pelo proponente, por
            seu representante ou por corretor de seguros habilitado. Para esta
            análise também serão consideradas as informações prestadas no
            Questionário de Avaliação do Risco. A seguradora terá o prazo de 15
            dias corridos — a contar da data de protocolização da proposta —
            para aceitar ou recusar o seguro. Não haverá cobertura para
            quaisquer eventos ocorridos em data anterior ao pedido de
            modificação do risco ou da inclusão de novas coberturas, ainda que
            tais eventos preexistentes tenham ocorrido dentro da vigência da
            apólice. No caso de solicitação de documentos complementares para a
            análise e aceitação do risco ou da alteração da proposta, o prazo de
            15 dias ficará suspenso, voltando a vigorar a partir da data da
            entrega da documentação. À vigência terá início e término às 00:00
            horas das datas indicadas na apólice. As condições
            contratuais/regulamento deste produto protocolizadas pela
            sociedade/entidade junto a SUSEP poderão ser consultadas no endereço
            eletrônico
            <a href="https://www.gov.br/susep/pt-br" target="_blank"
              >www.susep.gov.br</a
            >
            , de acordo com o número de processo constante nessa proposta.
          </h6>
        </div>
        <div class="mt-5 flex justify-end">
          <vs-button
            color="success"
            type="gradient"
            class="w-2/6 btn-print"
            @click="imprimePDF()"
          >
            Exportar PDF
          </vs-button>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import service from '../../services';
import functions from '../../utils/functions.js';
import locale from './../../locale';
import VxCard from '../../components/vx-card/VxCard.vue';
import lifeApiService from '../../services/life-api';
import { TIPO_APOLICE } from '../../../common/constant/tipo_apolice.js';
import { SUSEP_CODE } from '../../constants/susep.code.enum.js';

export default {
  data() {
    return {
      SUSEP_CODE,
      dadosProposta: {},
      lifeData: {},
      textoContrato: '',
      functions,
      dadosSaude: [],
    };
  },
  computed: {
    titulo() {
      const adesao = this.dadosProposta.dataAdesao;
      if (adesao) {
        return 'Apólice de Seguro';
      } else {
        return 'Proposta de Seguro';
      }
    },
  },
  methods: {
    formataNumeroProposta(idProposta) {
      return functions.formatEmitterNumber(
        idProposta,
        TIPO_APOLICE.VIDA,
        'PROPOSAL',
      );
    },
    formataNumeroApolice(policyNumber) {
      return functions.formatEmitterNumber(
        policyNumber,
        TIPO_APOLICE.VIDA,
        'POLICY',
      );
    },
    imprimePDF() {
      window.print();
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    formataDataContrato(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    somaValorTotalValoresAvista(arr1) {
      var total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal != true) total = total + element.valorFinal;
        });
      return total;
    },
    getAgravoPergunta(item) {
      const [pergunta] = Object.keys(item);
      return pergunta;
    },
    getAgravoResposta(item) {
      const [resposta] = Object.values(item);
      return resposta.resposta;
    },
    somaValorTotalMensal(arr1) {
      var total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal == true) total = total + element.valorFinal;
        });
      return total;
    },
    getRespostas(answers) {
      return answers.map((answer) => answer.response).join('; ');
    },
    getCarencia(waitingPeriod) {
      if (!waitingPeriod || waitingPeriod == 0) {
        return 'Não Possui';
      }

      return waitingPeriod;
    },
    getFranquia(deductible) {
      if (!deductible || deductible == 0) {
        return 'Não Possui';
      }

      return deductible;
    },
    getValorIof(valor, iof) {
      return valor * (iof / 100);
    },
    getValorPremioLiquido(valor, iof) {
      return valor - this.getValorIof(valor, iof);
    },
    getNumeroApolice(numero) {
      return numero.toString().padStart(6, '0');
    },
    getIdFormatado(numero) {
      return numero.toString().padStart(6, '0');
    },
    getIdPropostaStar(id) {
      return this.formataNumeroProposta;
    },
    getIdApoliceStar(id) {
      return `N° ${functions.formatEmitterNumber(
        id,
        TIPO_APOLICE.VIDA,
        'POLICY',
      )}`;
    },
    buscaDados() {
      if (this.$route.query.interno) {
        this.isInterno = true;
      } else {
        this.isInterno = false;
      }
      this.$vs.loading();
      var objSend = {};
      objSend.chave = this.$route.params.chave;
      objSend.idProposta = this.$route.params.idProposta;

      service
        .post(
          'CotacaoAberta',
          'buscaDadosVida?contractPdfLog=proposal-life',
          objSend,
        )
        .then(async (res) => {
          this.dadosProposta = res.data[0];
          const contractPdfLog = res.data[0].dataAdesao
            ? 'policy-life'
            : 'proposal-life';

          this.lifeData = await lifeApiService.getLifePolicy(
            this.dadosProposta.idApolice,
            contractPdfLog,
          );

          this.combinedData();

          let textoContrato = res.data[0].termos.find(
            (x) => x.tipoContrato == 'Termo de Ativação',
          );
          if (this.dadosProposta.tipoProposta == 'Reativação') {
            textoContrato = res.data[0].termos.find(
              (x) => x.tipoContrato == 'Termo de Reativação',
            );
          }
          this.textoContrato = textoContrato && textoContrato.modeloContrato;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    combinedData() {
      const combined = [];

      if (this.lifeData.prospect.height) {
        const height = this.lifeData.prospect.height.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
        });
        combined.push({
          id: 'height',
          question: 'Altura',
          response: `${height} m`,
        });
      }

      if (this.lifeData.prospect.weight) {
        combined.push({
          id: 'weight',
          question: 'Peso',
          response: `${this.lifeData.prospect.weight} kg`,
        });
      }

      this.lifeData.increases.forEach((increase) => {
        increase.answers.forEach((answer) => {
          let existingEntry = combined.find(
            (item) =>
              item.id === increase.id && item.question === increase.question,
          );

          if (!existingEntry) {
            existingEntry = {
              id: increase.id,
              question: increase.question,
              response: [],
            };
            combined.push(existingEntry);
          }

          existingEntry.response.push(answer.response);

          answer.sub_questions.forEach((subQuestion) => {
            let response = subQuestion.response;
            if (typeof subQuestion.response === 'boolean') {
              response = subQuestion.response ? 'Sim' : 'Não';
            }

            combined.push({
              id: `${increase.id}-${answer.id}-${subQuestion.id}`,
              question: subQuestion.question,
              response: response,
            });
          });
        });
      });

      combined.forEach((entry) => {
        if (Array.isArray(entry.response)) {
          entry.response = entry.response.join(', ');
        }
      });

      this.dadosSaude = combined;
    },
  },
  created() {
    this.buscaDados();
    this.$validator.localize('ptBr', locale);
  },
  components: { VxCard },
};
</script>

<style>
@import url('https://fonts.cdnfonts.com/css/gotham');

.cabecalho-impressao {
  display: none;
}

.wrapperPage {
  font-family: 'regular', 'Gotham', sans-serif;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
}

.img-logo {
  width: 200px;
  height: 100px;
}

table {
  width: 100%;
  gap: 20px;
}

tr:nth-child(odd) {
  background-color: #edf4fb;
}

.title {
  background-color: #043562 !important;
  color: white;
}

.listItemsProtecoes {
  color: rgb(59, 59, 59);
  font-size: 0.9rem;
  font-weight: 600;
}

.textoRodape {
  font-family: 'Roboto', sans-serif;
  color: #3e3e3e;
  font-size: 0.75rem;
  font-weight: 400;
  text-align: justify;
  text-justify: inter-word;
}

.container-assinaturas {
  height: 200px;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
}

.A3 .sheet {
  width: 297mm;
  height: 419mm;
}
.A3.landscape .sheet {
  width: 420mm;
  height: 297mm;
}
.A4 .sheet {
  width: 210mm;
  height: 297mm;
}
.A4.landscape .sheet {
  width: 297mm;
  height: 210mm;
}
.A5 .sheet {
  width: 148mm;
  height: 210mm;
}
.A5.landscape .sheet {
  width: 210mm;
  height: 147mm;
}

/** Padding area **/
.sheet.padding-10mm {
  padding: 10mm;
}
.sheet.padding-15mm {
  padding: 15mm;
}
.sheet.padding-20mm {
  padding: 20mm;
}
.sheet.padding-25mm {
  padding: 25mm;
}
/** For screen preview **/
@media screen {
  body {
    background: #e0e0e0;
    display: flex;
    justify-content: center;
  }
  .sheet,
  .quebraPagina {
    background: white;
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
    margin-top: 1em;
    margin-bottom: 1em;
  }
}

@page {
  size: A4;
  margin: 1cm;
}

/* Defina o conteúdo do rodapé no formato "Página X de Y" no centro do rodapé */
@page {
  @bottom-center {
    content: 'Página ' counter(page) ' de ' counter(pages);
  }
}

/** Fix for Chrome issue #273306 **/
@media print {
  .A3.landscape {
    width: 420mm;
  }
  .A3,
  .A4.landscape {
    width: 297mm;
  }
  .A4,
  .A5.landscape {
    width: 210mm;
  }
  .A5 {
    width: 148mm;
  }
}
@media screen {
  .printer {
    display: none;
  }
}
@media print {
  .non-printer {
    display: none;
  }
  .vue-back-to-top {
    display: none !important;
  }
  .pdf {
    width: auto;
    height: 200mm;
  }
  .folha {
    height: 297mm;
    padding: 0 0 0 0;
    page-break-after: always;
  }
  .btn-print {
    display: none;
  }
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .router-header,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
  .pagebreak-before {
    break-before: always;
    page-break-before: always;
  }
  .pagebreak-after {
    break-after: always;
    page-break-after: always;
  }
  .pagebreak-inside-avoid {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .vx-card__body {
    padding: 0.5rem !important;
    margin: 0 !important;
  }
  .img-logo {
    width: 100px;
    height: 50px;
  }
  .wrapperPage {
    padding-top: 1em !important;
  }
  .cabecalho-impressao {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
  @page {
    size: A4;
    margin: 0;
  }
}
</style>
